import React from "react";
import { Layout, Input, Avatar, Badge, Dropdown, Space } from "antd";
import {
    SearchOutlined,
    BellOutlined,
    UserOutlined,
    LogoutOutlined
} from "@ant-design/icons";
import { useAuth } from "../../contexts/auth-context";
import { useNavigate } from "react-router-dom";
import type { MenuProps } from "antd";

const { Header } = Layout;

export const CustomHeader: React.FC = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const displayName = (() => {
        if (!user) return "User";
        const fullName = `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();
        return fullName || user.username || user.email || "User";
    })();

    const userMenuItems: MenuProps["items"] = [
        {
            key: "logout",
            icon: <LogoutOutlined />,
            label: "Logout",
            onClick: () => {
                logout();
                navigate("/login");
            },
        },
    ];

    return (
        <Header className="custom-header">
            <div className="header-content">
                {/* Search */}
                <div className="header-search">
                    <Input
                        prefix={<SearchOutlined className="search-icon" />}
                        placeholder="Search..."
                        className="search-input"
                        bordered={false}
                    />
                </div>

                {/* Right Side Actions */}
                <div className="header-actions">
                    {/* Notifications */}
                    <Badge count={0} size="small">
                        <div className="action-btn">
                            <BellOutlined />
                        </div>
                    </Badge>

                    {/* User Menu */}
                    <Dropdown menu={{ items: userMenuItems }} placement="bottomRight" trigger={["click"]}>
                        <div className="user-profile">
                            <Avatar
                                size={36}
                                icon={<UserOutlined />}
                                className="user-avatar"
                            />
                            <span className="user-name">{displayName}</span>
                        </div>
                    </Dropdown>
                </div>
            </div>
        </Header>
    );
};
